export default "__VITE_ASSET__DNRqWc2x__"